export default __webpack_public_path__ + "static/media/Seta Saída.0116ded2.svg";